import CommonPageHeader from '@/components/common-page-header';
import { Button } from 'antd';
import IconTip from '@/components/icon-tip';
import CreateModal from '@/components/create-modal';
import { useState, useEffect, useRef } from 'react';
import apis from '../../apis';
import { connect } from 'react-redux';
import AddErpUser from '@/components/add-erp-user';
import history from '@/history';

const Header = (props) => {
  const [visible, setVisible] = useState(false);
  const [list, setList] = useState([]);
  const manageRef = useRef(null);
  useEffect(() => {
    apis.roleMembers({ erp: props.erp, onlyAssigned: 0, currentPage: 1, pageSize: 10, roleId: 17 }).then((res) => {
      const {
        ret,
        data: { list = [] },
      } = res;
      if (ret === '0') {
        setList(list);
      }
    });
  }, [props.erp]);

  function addErpUser() {
    manageRef.current.open({
      type: 'list',
      title: (
        <>
          上场审核组设置
          <span style={{ fontSize: '14px', fontWeight: 'normal' }}>
            &nbsp;
            <IconTip title="用于微频道的查询、下线管理等权限控制" type="question" />
          </span>
        </>
      ),
      onDeleteItem: (item, onDeleteSuccess) => {
        apis
          .delErp({ erps: item.erp, roleId: 18 })
          .then((res) => {
            if (res.ret === '0') onDeleteSuccess();
            else message.error(res.msg || '网络异常请稍后');
          })
          .catch((ex) => {
            message.error('网络异常请稍后');
          });
      },
      onOk: async (nowformData, successCallBack) => {
        const list = nowformData.erps;
        const { ret, msg, data } = (await apis.addErp({ roleId: 18, erps: list })) || {};
        if (ret === '0') {
          // message.success('上传成功！');
          successCallBack({ success: data.success, failure: data.failure, reasons: data.reasons });
        } else {
          message.error(msg || '上传失败');
        }
      },
      fetchErpList: () => {
        return apis.roleMembers({ roleId: 18, onlyAssigned: 0, currentPage: 1, pageSize: 100 }).then((res) => {
          if (res && res.ret === '0' && res.data?.list) {
            return res.data.list;
          }
          throw new Error(res.msg);
        });
      },
    });
  }

  return (
    <>
      <CommonPageHeader
        title="微频道管理"
        container={{
          padding: { vertical: 'max', horizontal: 'max' },
          margin: false,
        }}
        size="large"
        style={{
          background: 'linear-gradient(270deg, #F5FBFF 0%, rgba(245, 251, 255, 0) 100%)',
          border: '1px solid #F0F0F0',
        }}
        extra={[
          list.length > 0 && (
            <Button type="primary" shape="round" ghost key={1} onClick={addErpUser}>
              上场审核组设置
            </Button>
          ),
          <Button
            type="primary"
            shape="round"
            ghost
            key={1}
            onClick={() =>
              window.open('/batch-micro#/integration/batchcreate?isMicroChannel=1&origin=yx', '_blank', 'noopener')
            }
          >
            批量创建页面
            <IconTip title="支持按照页面模版批量搭建频道页面，后续创建微频道时可以直接关联页面。" type="question" />
          </Button>,
          <Button shape="round" type="primary" key={2} onClick={() => setVisible(true)}>
            + 新建微频道
          </Button>,
        ]}
        description="微频道是针对特定品类和营销场景，通过页面模版快捷搭建的营销场。"
      />
      <CreateModal
        visible={visible}
        onCancel={() => setVisible(false)}
        title="请选择您要进入新建微频道流程"
        tipsinfo="流程选择后不能再变更，请查看流程介绍后认真选择哦！"
        left={
          <div>
            <span className="create-modal-title">通天塔建场</span>
            <span className="create-modal-content">支持按照通天塔模版快捷搭建频道页面，并与微频道进行关联。</span>
          </div>
        }
        right={
          <div>
            <span className="create-modal-title">指南针建场</span>
            <span className="create-modal-content">
              支持通过指南针系统创建微频道，如无指南针系统权限可联系接口人diaoshiliang
            </span>
          </div>
        }
        toCreateLeft={() => {
          setVisible(false);
          history.push('/channel-micro/add-channel');
        }}
        toCreateRight={() => {
          setVisible(false);
          window.open('http://cop.jd.com/view/scene-list', '_blank', 'noopener');
        }}
      />
      <AddErpUser ref={manageRef} />
    </>
  );
};
export default connect((state) => {
  if (!state.userInfo.userMap || !state.userInfo.userMap.erp) return {};
  return {
    erp: state.userInfo.userMap.erp,
  };
})(Header);
